/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取空中写号申请记录列表
export function listWriteCardApply(params) {
    return request({
        url: 'writeCardApply/list.do?',
        method: 'post',
        data: params
    })
}

// 导出空中写号申请记录
export function exportWriteCardApply(params) {
    return request({
        url: 'writeCardApply/export.do?',
        method: 'post',
        data: params
    })
}

// 批量导入空中写号申请记录
export function batchImportWriteCardApply(params) {
    return request({
        url: 'writeCardApply/batchImportApplyRecord.do?',   
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 取消写号申请
export function cancelWriteCardApply(params) {
    return request({
        url: 'writeCardApply/cancelWriteCardApply.do?',
        method: 'post',
        data: params
    })
}

// 更新写号状态
export function queryAndUpdateWriteCardStatusByServer(params) {
    return request({
        url: 'writeCardApply/queryAndUpdateWriteCardStatusByServer.do?',
        method: 'post',
        data: params
    })
}

// 批量更新写号状态
export function batchUpdateWriteCardStatus(params) {
    return request({
        url: 'writeCardApply/batchUpdateWriteCardStatus.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 批量取消写号
export function batchCancelWriteCardApply(params) {
    return request({
        url: 'writeCardApply/batchCancelWriteCardApply.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
} 